/**
 * Formats a price value for display
 * @param price - The price value to format
 * @returns Formatted price string with 2 decimal places, or empty string if invalid/zero
 */
export const formatPrice = (price: number | null | undefined): string => {
  if (price === null || price === undefined || typeof price !== 'number' || isNaN(price) || price === 0) return '';
  return price.toFixed(2);
};

/**
 * Converts influence type value to Ukrainian label
 * @param value - The influence type value
 * @returns Localized influence type label
 */
export const getInfluenceTypeLabel = (value: string | undefined): string => {
  if (!value) return '';
  const influenceTypes = [
    { value: 'max', label: 'макс.' },
    { value: 'medium', label: 'сер.' },
    { value: 'min', label: 'мін.' },
    { value: 'none', label: 'не впл.' },
    { value: 'distant', label: 'віддалена' },
    { value: 'nearby', label: 'поблизу' }
  ];
  const type = influenceTypes.find(t => t.value === value);
  return type ? type.label : value;
};

/**
 * Converts location type value to Ukrainian label
 * @param value - The location type value
 * @returns Localized location type label
 */
export const getLocationTypeLabel = (value: string | undefined): string => {
  if (!value) return '';
  const locationTypes = [
    { value: 'same_side_after', label: 'з однієї після нашої' },
    { value: 'same_side_before', label: 'з однієї перед нашою' },
    { value: 'opposite', label: 'навпроти' },
    { value: 'nearby', label: 'поблизу' },
    { value: 'distant', label: 'віддалена' }
  ];
  const type = locationTypes.find(t => t.value === value);
  return type ? type.label : value;
};

/**
 * Returns Unicode arrow icon for price change direction
 * @param change - Price change direction ('up', 'down', or other)
 * @returns Unicode arrow character or empty string
 */
export const getPriceChangeIcon = (change: string | undefined): string => {
  switch (change) {
    case 'up':
      return '↑';
    case 'down':
      return '↓';
    default:
      return '';
  }
};
